import { Component, OnInit } from '@angular/core';
import { AppState } from '@app/core/ngrx';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';

@Component({
  selector: 'ecp-tab4',
  templateUrl: './tab4.component.html',
  styleUrls: ['./tab4.component.scss'],
})
export class Tab4Component implements OnInit {
  // @select(['media', 'list', 'tab4'])
  tab4$: Observable<any>;

  /**
   * constructor
   * @param {NgRedux<AppState>} redux
   */

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.tab4$ = this.store.pipe(select(state => state.media.list.tab4));
    window.console.log(this.tab4$);
  }
}
